import { IRoles } from "../../../utils";

export const FEATURE_WIDGET_PERMISSIONS = {
  ClientWidget: [IRoles.Business, IRoles.Admin, IRoles.SuperAdmin, IRoles.Manager, IRoles.VR, IRoles.Other],
  QuotesWidget: [IRoles.Business, IRoles.Manager, IRoles.VR, IRoles.Other],
  WorkforceWidget: [IRoles.Business, IRoles.Manager, IRoles.VR, IRoles.Other],
  CalculatorWidget: [IRoles.Business, IRoles.Manager, IRoles.VR, IRoles.Other],
  JobsWidget: [IRoles.Business, IRoles.Manager, IRoles.VR, IRoles.Other],
  FlowDoWidget: [IRoles.Business, IRoles.Admin, IRoles.SuperAdmin, IRoles.Manager, IRoles.VR, IRoles.Other],
  InvoiceWidget: [IRoles.Business, IRoles.Manager, IRoles.VR, IRoles.Other],
  JobsCalendarWidget: [IRoles.Business, IRoles.Employee, IRoles.Manager, IRoles.VR, IRoles.Other],
  ConnectionsWidget: [IRoles.Business, IRoles.Employee, IRoles.Manager, IRoles.VR, IRoles.Other],
  SOWWidget: [IRoles.SuperAdmin, IRoles.Admin],
  AppVersionsWidget: [IRoles.SuperAdmin],
  ContactCenterWidget: [IRoles.SuperAdmin],
};
